export function getCheckoutOptionEntityId(option, fieldName) {
	if (!option) {
		return null;
	}

	if (option[fieldName] != null && option[fieldName] !== '') {
		return option[fieldName];
	}

	const value = option.value;
	if (typeof value === 'string' && value.indexOf(':') !== -1) {
		return value.split(':')[1];
	}

	return null;
}
